import { getTableColumns } from 'helpers';

const RestrictionColumns = [
  ['restrictionType', 'string', 'Restriction Type', 'left', true],
  ['participant', 'string', 'Restriction To', 'left', true],
  ['roleType', 'string', 'Role Type', 'left', true],
  ['startDate', 'date', 'Start Date', 'center', true],
  ['endDate', 'date', 'End Date', 'center', true],
  ['dataSource', 'string', 'Data Source', 'left', true]
];

const RestrictionForColumns = [
  ...getTableColumns(RestrictionColumns),
  {
    name: 'esysStatus',
    type: 'object',
    label: 'Status',
    filterable: true,
    optionList: [
      { label: 'Active', value: 'Active' },
      { label: 'Inactive', value: 'Inactive' }
    ]
  }
];


export default RestrictionForColumns;
